'use client';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import React from 'react';
import { mapModifiers } from '@/utils/funtion';
import Typography from '@/components/atoms/typography';
type Variant = 'normal' | 'transparent';

interface RichTextEditorProps {
  handleOnChange?: (item: string) => void;
  data?: string;
  isUseHeader?: boolean;
  isDisabled?: boolean;
  type?: Variant;
  label?: string;
  errorMessage?: string;
  placeholder?: string;
}

const toolbarOptions = [
  [{ font: [] }, { size: ['small', false, 'large', 'huge'] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }, { background: [] }],
  [{ script: 'sub' }, { script: 'super' }],
  [{ header: '1' }, { header: '2' }, { header: [1, 2, 3, 4, 5, 6, false] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ direction: 'rtl' }],
  [{ align: [] }],
  ['link', 'image', 'video', 'blockquote', 'code-block'],
  ['clean'],
];

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  handleOnChange,
  data,
  isUseHeader,
  type,
  isDisabled,
  label,
  errorMessage,
  placeholder,
}) => {
  const modules = {
    toolbar: toolbarOptions,
  };

  return (
    <div
      className={mapModifiers(
        'm-richtext_editor',
        !isUseHeader && 'not-header',
        type,
        errorMessage ? 'error' : '',
      )}
    >
      <div className="m-richtext_editor_label">
        <Typography content={label} />
      </div>
      <ReactQuill
        theme="snow"
        value={data}
        onChange={handleOnChange}
        readOnly={isDisabled}
        placeholder={placeholder}
        modules={modules}
      />
      {errorMessage && (
        <div className="m-richtext_editor-error_message">{errorMessage}</div>
      )}
    </div>
  );
};

export default RichTextEditor;
